// extracted by mini-css-extract-plugin
export default {"statusBadge":"orderStatusBadge_statusBadge__eqxzM","fadeIn":"orderStatusBadge_fadeIn__JJklX"};